<script lang="ts">
	import { getContext } from "svelte";
	import { contextKey } from "@beyonk/svelte-mapbox/src/lib/components";
	export let cords;

	const { getMap, getMapbox } = getContext(contextKey)
	const map = getMap()
  	const mapbox = getMapbox()
	  map.addSource('route', {
		type: 'geojson',
		data: {
			type: 'Feature',
			properties: {},
			geometry: {
				type: 'LineString',
				coordinates: cords
			}
		}
	});
	map.addLayer({
		id: 'route',
		type: 'line',
		source: 'route',
		layout: {
			'line-join': 'round',
			'line-cap': 'round'
		},
		'paint': {
			'line-color': '#BD00FF',
			'line-width': 8
		}
	});

	setInterval(() => {
		map.removeLayer("route");
		map.removeSource("route");
		map.addSource('route', {
		type: 'geojson',
		data: {
			type: 'Feature',
			properties: {},
			geometry: {
				type: 'LineString',
				coordinates: cords
			}
		}
	});
	map.addLayer({
		id: 'route',
		type: 'line',
		source: 'route',
		layout: {
			'line-join': 'round',
			'line-cap': 'round'
		},
		'paint': {
			'line-color': '#BD00FF',
			'line-width': 8
		}
	});
	}, 5000)
</script>